import { render, staticRenderFns } from "./reclamosLeecherosTerminados.vue?vue&type=template&id=9bb25aee"
import script from "./reclamosLeecherosTerminados.vue?vue&type=script&lang=js"
export * from "./reclamosLeecherosTerminados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports